; (function (jQuery) {

	"use strict";

	function AppForm() {
		var global = {
			tabletBreakpoint: 768,
			$infoSourceLevel1Select: jQuery('select[name="info_source_level_1"]'),
			$infoSourceLevel2Select: jQuery('select[name="info_source_level_2"]'),
			$infoSourceAnyLevelSelect : jQuery('select[name="info_source_level_1"], select[name="info_source_level_2"]'),
		};

		var fn = {
			init: function ()
			{
				jQuery('.js-remove-toggle').on('click', fn.toggleItemRemoveOverlay);
				jQuery('.js-remove-cart-item').on('click', fn.triggerRemoveCartItem);
				jQuery('.js-remove-cart-addon').on('click', fn.triggerRemoveCartAddon);
				jQuery('.js-cart-modal-toggle').on('click', fn.toggleCartModalOverlay);

				jQuery('.js-dob-day, .js-dob-month, .js-dob-year').on('change', fn.handleDateOfBirthChange);
				fn.handleDateOfBirthChange();

				jQuery(window).on('resize', fn.updateMobileProgressBarItem);
				fn.updateMobileProgressBarItem();

				fn.handleCurrencyDropdown();

				jQuery(window).on('resize', fn.handleCurrencyDropdownMobileText);
				fn.handleCurrencyDropdownMobileText();

				fn.handleInfoSourceConditionalDislay();
				fn.triggerInputContentClass();

				// Trip selector dynamic fields
				jQuery('#appform-react-root').on('input', '.appform-field input', function () {
					fn.toggleInputHasContentClass(jQuery(this));
				});
				jQuery('#appform-react-root').on('change', '.appform-field select', function() {
					fn.toggleInputHasContentClass(jQuery(this));
				});

				fn.removeValidationErrorsOnInput();
			},

			/**
			 * Remove error state from input after use has entered a value
			 */
			removeValidationErrorsOnInput: function ()
			{
				jQuery('.appform-field.has-error input, .appform-field.has-error select').on('blur', function ()
				{
					//Check user has entered value, and it's not the same as the one previously entered
					if (jQuery(this).val() && jQuery(this).val() != jQuery(this).attr('value'))
					{
						jQuery(this).parents('.appform-field.has-error').removeClass('has-error').find('.appform-field__label--error').hide();
					}
				})
			},

			/**
			 * Save users currency preference to session
			 */
			handleCurrencyDropdown: function()
			{
				jQuery('select.appform-header__currency-select').change(function()
				{
					let $this = jQuery(this);

					//Update the icon
					let icon_url = $this.find('option:selected').attr('data-icon-url');
					let chevron_url = window.location.origin + '/app/themes/projects-abroad/images/circle-chevron-down.svg';
					$this.attr('style', "background-image: url('"+icon_url+"'), url('"+chevron_url+"');");

					//Submit the value to the user session
					let user_currency = $this.val();
					let rest_endpoint_url = '/wp-json/pa/application-form/user-currency'
					$this.attr('disabled', 'disabled');
					jQuery.ajax({
						type: "post",
						dataType: "json",
						url: rest_endpoint_url,
						data: {
							'action' : 'save_user_currency_choice',
							'user_currency' : user_currency,
						},
						success: function(msg){
							$this.removeAttr('disabled');
							//Currency can be set via get param
							window.location.href = location.pathname;
						},
						error: function(msg){
							alert('An error has occurred. Please wait and try again later.');
							$this.removeAttr('disabled');
						}
					});
				})
			},

			/**
			 * Replace full currency selector text (e.g. '£ UK Pounds (GBP)')
			 * on mobile, to show only option value i.e. currency code 'GBP'.
			 * Store original text to restore if required on browser resize.
			 */
			handleCurrencyDropdownMobileText: function()
			{
				var currencySelect = jQuery('.appform-header__currency-select');
				var currencyOptions = currencySelect.find('option');
				var isMobile = window.innerWidth < 550; // mobile breakpoint

				currencyOptions.each(function()
				{
					var option = jQuery(this);
					var currencyCode = option.val();

					if (isMobile)
					{
						if (!option.data('originalText')) {
							option.data('originalText', option.text());
						}
						option.text(currencyCode.toUpperCase());
					}
					else
					{
						var originalText = option.data('originalText');

						if (originalText) {
							option.text(originalText);
						}
					}
				});
			},

			//Conditionally show/hide how did you hear about us options
			handleInfoSourceConditionalDislay : function()
			{
				//Only run if infosource level 1 present
				if(global.$infoSourceLevel1Select.length === 0) {
					return;
				}

				global.$infoSourceLevel1Select.on('change', fn.onSourceLevelOneChange);
				global.$infoSourceAnyLevelSelect.on('change', fn.infoSourceAnyLevelSelect);

				// On load trigger change events
				fn.onSourceLevelOneChange();
				if (global.$infoSourceLevel2Select.find(`option[value='${pa_info_source_level_2_value}']`).length > 0) {
					global.$infoSourceLevel2Select.val(pa_info_source_level_2_value);
				}
				fn.infoSourceAnyLevelSelect();
			},

			/**
			 * Show the secondary dropdown if there are child options
			 */
			onSourceLevelOneChange : function()
			{
				let $infoSourceLevel2SelectWrapper = jQuery('.info-source-level-2-wrapper');
				let sourceId = global.$infoSourceLevel1Select.find('option:selected').attr('data-info-source-id');
				let hasSecondLevelOptions = sourceId in pa_second_level_sources;
				if(!hasSecondLevelOptions) {
					//No secondary options. Hide the second select and clear its value
					global.$infoSourceLevel2Select.empty();
					$infoSourceLevel2SelectWrapper.hide();
					global.$infoSourceLevel2Select.val('');
				} else {
					//There are secondary options. Show select wrapper and add relevant items to the 2nd dropdown
					let newElements = new Array();
					jQuery.each(pa_second_level_sources[sourceId], function(key, value) {
						newElements.push(jQuery("<option></option>")
						   .attr("value", value['value'])
						   .text(value['text'])
						   .attr('data-info-show-explain', value['show_explain']));
					});

					global.$infoSourceLevel2Select.empty();
					global.$infoSourceLevel2Select.html(newElements);
					$infoSourceLevel2SelectWrapper.show();
				}
			},

			/**
			 * Show please explain when flag present in selected options
			 */
			infoSourceAnyLevelSelect : function()
			{
				let show_explain_level_1 = jQuery('select[name="info_source_level_1"] option:selected').attr('data-info-show-explain');
				let show_explain_level_2 = jQuery('select[name="info_source_level_2"] option:selected').attr('data-info-show-explain');
				let $pleaseExplainWrapper = jQuery('.please-explain-wrapper');
				let $pleaseExplainInput = jQuery('.please-explain-wrapper input');
				if(show_explain_level_1 == '1' | show_explain_level_2 == '1') {
					$pleaseExplainWrapper.show()
				} else {
					$pleaseExplainWrapper.hide();
					$pleaseExplainInput.val('');
				}
			},

			calculateAge: function(birthDateJsDateObject) {
				const today = new Date();
				let age = today.getFullYear() - birthDateJsDateObject.getFullYear();
				const m = today.getMonth() - birthDateJsDateObject.getMonth();
				if (m < 0 || (m === 0 && today.getDate() < birthDateJsDateObject.getDate())) {
					age -= 1;
				}
				return age;
			},

			// We only show the guardian details section if the applicant is under 18
			handleDateOfBirthChange: function() {
				const day = jQuery('.js-dob-day').val();
				const month = jQuery('.js-dob-month').val();
				const year = jQuery('.js-dob-year').val();

				const validDay = day && day > 0 && day <= 31;
				const validMonth = month && month > 0 && month <= 12;
				const validYear = year && year.length == 4 && year <= new Date().getFullYear();

				if (validDay && validMonth && validYear) {
					const dob = new Date(year, month - 1, day); // Month index between 0 and 11
					const age = fn.calculateAge(dob);
					const isUnder18 = age < 18;

					if (isUnder18) {
						jQuery('.js-guardian-details').show();
					}
					else {
						jQuery('.js-guardian-details').hide();
					}
				}
			},

			toggleItemRemoveOverlay: function()
			{
				if (!jQuery(this).parents('.appform-cart-item').hasClass('appform-cart-item--remove')) {
					jQuery('.appform-cart-item--remove').removeClass('appform-cart-item--remove');
				}

				jQuery(this).parents('.appform-cart-item').toggleClass('appform-cart-item--remove');
			},

			triggerRemoveCartItem: async function()
			{
				let cartItem = jQuery(this).parents('.appform-cart-item');
				let cartItemId = cartItem.attr('data-id');

				jQuery(`.appform-cart-item[data-id="${cartItemId}"]`).remove();
				jQuery(`.hidden-cart-item[data-cart-id="${cartItemId}"]`).remove();

				const cartItemRemovedEvent = new CustomEvent('paCartItemRemoved', {
					detail: {
						cartItemId: cartItemId
					}
				});
				window.dispatchEvent(cartItemRemovedEvent);

				let data = {
					cart_item_id: cartItemId
				};

				const response = await fetch('/wp-json/pa/application-form/remove-cart-item', {
					method: 'POST',
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(data),
				});

				const cartTotals = await response.json();

				fn.updateCartTotals(cartTotals);

				if (!jQuery('.appform-cart-item').length) {
					window.location = window.location;
				}
			},

			triggerRemoveCartAddon: async function()
			{
				let cartItem = jQuery(this).parents('.appform-cart-item');
				let cartItemId = cartItem.attr('data-id');
				let addonId = cartItem.attr('data-addon-id');

				jQuery(`.appform-cart-item[data-id="${cartItemId}"][data-addon-id="${addonId}"]`).remove();

				let data = {
					cart_item_id: cartItemId,
					addon_id: addonId
				};

				const response = await fetch('/wp-json/pa/application-form/remove-cart-addon', {
					method: 'POST',
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(data),
				});

				const cartTotals = await response.json();

				fn.updateCartTotals(cartTotals);
			},

			updateCartTotals: function (cartTotals)
			{
				// console.log(cartTotals);

				if (!cartTotals)
				{
					return;
				}

				const hasDiscount = cartTotals.discountAmount && parseFloat(cartTotals.discountAmount) > 0;
				if (hasDiscount) {
					jQuery('.js-discount-price-container').css('display', 'block');
					jQuery('.js-discount-price').text(cartTotals.discountAmount);
				}
				else {
					jQuery('.js-discount-price-container').css('display', 'none');
				}

				if (cartTotals.totalPrice) {
					jQuery('.js-total-price').text(cartTotals.totalPrice);
				}
			},

			updateMobileProgressBarItem: function ()
			{
				if (jQuery(window).width() < global.tabletBreakpoint)
				{
					var lastProgressBarItem = jQuery('.appform-header__progress-item:last-of-type');
					var lastProgressBarItemText = lastProgressBarItem.find('.progress-item__text');

					// Show last item text when marked completed, as well as active
					if (lastProgressBarItem.is('.active, .completed'))
					{
						lastProgressBarItemText.css('display', 'inline-block'); // placeholder active/completed class names
					}
				}
			},

			toggleCartModalOverlay: function ()
			{
				jQuery('.appform-cart-modal-container').toggleClass('appform-cart-modal--open');
			},

			triggerInputContentClass: function ()
			{
				jQuery('.appform-field input, .appform-field select').each(function ()
				{
					fn.toggleInputHasContentClass(jQuery(this));
				});

				jQuery('.appform-field input').on('input', function ()
				{
					fn.toggleInputHasContentClass(jQuery(this));
				});

				jQuery('.appform-field select').on('change', function ()
				{
					fn.toggleInputHasContentClass(jQuery(this));
				});
			},

			toggleInputHasContentClass: function(element)
			{
				if (element.val() && element.val().trim() !== '')
				{
					element.addClass('appform-field--has-content');
				}
				else
				{
					element.removeClass('appform-field--has-content');
				}
			}
		}

		jQuery(fn.init);
	}

	new AppForm();
})(jQuery);